import React from 'react';
import { useDispatch } from 'react-redux';
import Notifier from './Notifier';
import CssBaseline from '@mui/material/CssBaseline';
import Content from 'src/domains/global/views/Content';
import { setBaseUrl } from 'src/domains/global/actions';
import { clear } from 'src/domains/networklog/actions';

const LOCAL_DEV_MODE: boolean = false; // Do not forget to set to false for production builds, otherwise all user apps will try to connect to localhost:8090
const DEBUG: boolean = false;

const getBaseUrl: () => string = () => {
    let baseUrl;
    if (LOCAL_DEV_MODE) {
        const host = 'localhost';
        const port = '8090';
        baseUrl = `http://${host}:${port}`;
    } else {
        baseUrl = process.env.PUBLIC_URL;
    }
    if (DEBUG) {
        console.log('app ver.:', '1');
        console.log('baseUrl:', baseUrl);
    }
    return baseUrl!;
}

const App: React.FC = () => {
    const dispatch = useDispatch();
    const baseUrl = getBaseUrl();
    dispatch(setBaseUrl(baseUrl));
    dispatch(clear());

    return (
        <>
            <CssBaseline />
            <Notifier />
            <Content />
        </>
    );
};

export default App;
